import { createPartyRequest } from './helper';
export const getPartyDocumentsMetaData = createPartyRequest({
    route: '/party/parties/:partyNo/documentsmetadata',
    method: 'get',
    source: 'data',
});
